import React from 'react';
import { prop } from 'ramda';
import { compose, mapProps, pure } from 'recompose';
import withGameLaunch from 'js/components/common/Game/withGameLaunch';
import { useTranslations } from 'js/hooks/i18n';
import { useUserSelector } from 'js/store/hooks';
import { Button } from 'js/components/common/Button';
import { FavoriteIcon } from 'js/components/common/Game/FavoriteIcon';
import { DemoButton, PlayButton } from 'js/components/common/Game/Buttons';
import animCss from '../animation.scss';
import style from './index.scss';
import { useGameConfig } from '@core/js/components/common/Game';

export const RetryButton = ({ onClick }) => {
    const t = useTranslations();

    return (
        <Button
            className={`${style.btn} ${style.tryBtn}`}
            variant="rounded"
            onClick={onClick}>
            {t('playtech.mobile.system.lucky.text.tryAgain')}
        </Button>
    );
};

export const Description = ({ code }) => {
    const t = useTranslations();
    const tKey = `playtech.mobile.system.gamedescription.${code}`;
    const MAX_LENGTH = 145;
    let value = t(tKey);

    value = value.includes(tKey)
        ? ''
        : value.length > MAX_LENGTH ? `${value.substring(0, MAX_LENGTH)}...` : value;

    return value && <p className={style.desc}>{value}</p>;
};

export const gsClasses = {
    item: style.gameStudio
};

export const vlClasses = {
    item: style.volatility
};

export const HoveredGame = ({
    code,
    image,
    name,
    isLoggedIn,
    showDemoButton,
    setCurrentGameItem,
    onGameLaunched,
    btnProps = {
        onGameLaunched,
        code,
        name
    }
}) => (
    <div className={`${style.container} ${animCss.fadeIn}`}>
        <div className={style.content}>
            <div className={style.background} style={{ backgroundImage: `url(${image})` }}>
                <div className={style.overlay} />
                <div className={style.gameContent}>
                    <h3 className={style.title}>{name}</h3>
                    <div className={style.buttons}>
                        {showDemoButton && <DemoButton {...btnProps} className={style.btn} isHoverBtn={true} />}
                        <PlayButton {...btnProps} className={style.btn} isHoverBtn={true} />
                        <RetryButton onClick={() => setCurrentGameItem(null)} />
                    </div>
                    <Description code={code} />
                    {isLoggedIn && <FavoriteIcon
                        code={code}
                        className={style.favorite}
                    />}
                </div>
            </div>
        </div>
    </div>
);

export default compose(
    pure,
    withGameLaunch,
    mapProps(
        ({ demoModeSupport, gameCode: code, ...rest }) => {
            const isLoggedIn = useUserSelector(prop(['isLoggedIn']));
            const {
                images = {}
            } = useGameConfig(code);
            return {
                ...rest,
                code,
                isLoggedIn,
                image: !isLoggedIn && images.guest || images.base,
                showDemoButton: !(demoModeSupport === 'unavailable' || demoModeSupport === 'guest' && isLoggedIn)
            };
        }
    )
)(HoveredGame);
